module.exports = __webpack_public_path__ + "img/BOTON-ANTERIOR.29e4cde3.svg";